/** Brand Ads API helpers (BFF). */
import ApiService from '../../services/api';

const ads = {
  dashboard: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return ApiService.bffRequest(`/admin/ads/dashboard${q ? `?${q}` : ''}`);
  },
  listAdvertisers: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return ApiService.bffRequest(`/admin/ads/advertisers${q ? `?${q}` : ''}`);
  },
  getAdvertiser: (id) => ApiService.bffRequest(`/admin/ads/advertisers/${id}`),
  createAdvertiser: (body) =>
    ApiService.bffRequest('/admin/ads/advertisers', { method: 'POST', body: JSON.stringify(body) }),
  updateAdvertiser: (id, body) =>
    ApiService.bffRequest(`/admin/ads/advertisers/${id}`, { method: 'PUT', body: JSON.stringify(body) }),
  deleteAdvertiser: (id) =>
    ApiService.bffRequest(`/admin/ads/advertisers/${id}`, { method: 'DELETE' }),

  listCampaigns: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return ApiService.bffRequest(`/admin/ads/campaigns${q ? `?${q}` : ''}`);
  },
  getCampaign: (id) => ApiService.bffRequest(`/admin/ads/campaigns/${id}`),
  createCampaign: (body) =>
    ApiService.bffRequest('/admin/ads/campaigns', { method: 'POST', body: JSON.stringify(body) }),
  updateCampaign: (id, body) =>
    ApiService.bffRequest(`/admin/ads/campaigns/${id}`, { method: 'PUT', body: JSON.stringify(body) }),
  duplicateCampaign: (id) =>
    ApiService.bffRequest(`/admin/ads/campaigns/${id}/duplicate`, { method: 'POST', body: '{}' }),
  pauseCampaign: (id) =>
    ApiService.bffRequest(`/admin/ads/campaigns/${id}/pause`, { method: 'POST', body: '{}' }),
  resumeCampaign: (id) =>
    ApiService.bffRequest(`/admin/ads/campaigns/${id}/resume`, { method: 'POST', body: '{}' }),
  deleteCampaign: (id) =>
    ApiService.bffRequest(`/admin/ads/campaigns/${id}`, { method: 'DELETE' }),

  listPlacements: () => ApiService.bffRequest('/admin/ads/placements'),
  updatePlacement: (id, body) =>
    ApiService.bffRequest(`/admin/ads/placements/${id}`, { method: 'PUT', body: JSON.stringify(body) }),

  listLandingPages: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return ApiService.bffRequest(`/admin/ads/landing-pages${q ? `?${q}` : ''}`);
  },
  getLandingPage: (id) => ApiService.bffRequest(`/admin/ads/landing-pages/${id}`),
  createLandingPage: (body) =>
    ApiService.bffRequest('/admin/ads/landing-pages', { method: 'POST', body: JSON.stringify(body) }),
  updateLandingPage: (id, body) =>
    ApiService.bffRequest(`/admin/ads/landing-pages/${id}`, { method: 'PUT', body: JSON.stringify(body) }),
  deleteLandingPage: (id) =>
    ApiService.bffRequest(`/admin/ads/landing-pages/${id}`, { method: 'DELETE' }),

  getSettings: () => ApiService.bffRequest('/admin/ads/settings'),
  updateSettings: (body) =>
    ApiService.bffRequest('/admin/ads/settings', { method: 'PUT', body: JSON.stringify(body) }),

  campaignReport: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return ApiService.bffRequest(`/admin/ads/reports/campaigns${q ? `?${q}` : ''}`);
  },
  advertiserReport: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return ApiService.bffRequest(`/admin/ads/reports/advertisers${q ? `?${q}` : ''}`);
  },
  revenueReport: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return ApiService.bffRequest(`/admin/ads/reports/revenue${q ? `?${q}` : ''}`);
  },
  topReport: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return ApiService.bffRequest(`/admin/ads/reports/top${q ? `?${q}` : ''}`);
  },
  citiesReport: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return ApiService.bffRequest(`/admin/ads/reports/cities${q ? `?${q}` : ''}`);
  },
  devicesReport: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return ApiService.bffRequest(`/admin/ads/reports/devices${q ? `?${q}` : ''}`);
  },
  heatmap: (campaignId, params = {}) => {
    const q = new URLSearchParams(params).toString();
    return ApiService.bffRequest(`/admin/ads/reports/heatmap/${campaignId}${q ? `?${q}` : ''}`);
  },
  addRevenue: (body) =>
    ApiService.bffRequest('/admin/ads/revenue', { method: 'POST', body: JSON.stringify(body) }),

  exportUrl: (format, type, params = {}) => {
    const q = new URLSearchParams({ ...params, type }).toString();
    return `/api/v1/admin/ads/reports/export.${format}?${q}`;
  },

  async uploadImage(file) {
    const form = new FormData();
    form.append('image', file);
    return ApiService.bffRequest('/admin/ads/upload-image', {
      method: 'POST',
      body: form,
    });
  },
};

export default ads;
